import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { CSVLink } from "react-csv";

import { b2bNewsletterSignup, exportCatalog } from '../../redux/actions/otherActions';
import ExcelExportCatalog from './ExcelExportCatalog';
import LoaderMaskLine from '../other/LoaderMaskLine';
import { useTranslation } from 'react-i18next';

const HomePageExports = () => {
    const dispatch = useDispatch();
    const dataRef = useRef();

    const [newsletterEmail, setNewsletterEmail] = useState('');
    const [errors, setErrors] = useState(1);
    const [validInput, setValidInput] = useState(0);
    const [exportCatalogState, setExportCatalogState] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const { t } = useTranslation('customExportCatalog');

    const maxWarehouseItem = exportCatalogState.reduce((maxItem, item) => {
        const warehouses = item.warehouse ? (Array.isArray(item.warehouse) ? item.warehouse : Object.values(item.warehouse)) : [];
        return warehouses.length > maxItem.warehouse.length ? { ...item, warehouse: warehouses } : maxItem;
    }, { warehouse: [] });

    const warehouseNames = maxWarehouseItem.warehouse.map(wh => wh.acStockName);

    const warehouseColumns = warehouseNames.map(name => ({
        title: name,
        style: { font: { bold: true } },
        width: { wpx: 120 }
    }));


    const getWarehouseData = (product) => {
        const warehouses = product.warehouse ? (Array.isArray(product.warehouse) ? product.warehouse : Object.values(product.warehouse)) : [];
        const warehouseData = warehouses.reduce((map, wh) => {
            map[wh.acStockName] = wh.anStock;
            return map;
        }, {});

        return warehouseData;
    };

    const dataForCSV = exportCatalogState.map(product => ({
        acCategory: product.acCategory,
        acSubCategory: product.acSubCategory,
        acProduct: product.acProduct,
        acDept: product.acDept,
        acName: product.acName,
        anPrice: product.anPrice ? product.anPrice.toFixed(2) : "0.00",
        ...getWarehouseData(product),
        anRecommendedRetailPrice: product.anRecommendedRetailPrice,
        acEan: product.acEan ? `\t${product.acEan}` : "",
        acSupplier: product.acSupplier,
        acCountry: product.acCountry,
        acInlineSpecification: product.acInlineSpecification,
        anDimWeightBrutto: product.anDimWeightBrutto,
        anDimHeight: product.anDimHeight,
        anDimWidth: product.anDimWidth,
        anDimDepth: product.anDimDepth,
        anProductTransport: product.anProductTransport,
    }));

    const headers = [
        { label: t('kategorija'), key: 'acCategory' },
        { label: t('podkategorija'), key: 'acSubCategory' },
        { label: t('ident'), key: 'acProduct' },
        { label: t('proizvodjac'), key: 'acDept' },
        { label: t('naziv'), key: 'acName' },
        { label: t('cenaSaPopustom'), key: 'anPrice' },
        ...warehouseColumns.map(col => ({ label: col.title, key: col.title })),
        { label: t('preporucenaMpCena'), key: 'anRecommendedRetailPrice' },
        { label: t('ean'), key: 'acEan' },
        { label: t('uvoznik'), key: 'acSupplier' },
        { label: t('zPorekla'), key: 'acCountry' },
        { label: t('opis'), key: 'acInlineSpecification' },
        { label: t('tezina'), key: 'anDimWeightBrutto' },
        { label: t('visina'), key: 'anDimHeight' },
        { label: t('sirina'), key: 'anDimWidth' },
        { label: t("duzina"), key: 'anDimDepth' },
        { label: t("brKomada"), key: 'anProductTransport' },
    ];

    const onExportCatalog = (val) => {
        setShowLoader(true);
        dispatch(exportCatalog(val)).then(res => {
            setExportCatalogState(res);
            dataRef.current.click();
            setShowLoader(false);
        });
    };

    return (
        <div className="row home-page-exports">
            <div className="col-sm-12 export-buttons">
                <ExcelExportCatalog />
                {!showLoader ? (
                    <div className="btn btn-sm btn-newsletter text-center" onClick={() => onExportCatalog("csv")}>
                        <i className="fas fa-angle-double-down"></i>&nbsp; {t('exportCsv')}
                    </div>
                ) : (
                    <LoaderMaskLine />
                )}
                <CSVLink
                    filename={t('proizvodi') + Date.now() + ".csv"}
                    data={dataForCSV}
                    headers={headers}
                    target="_parent"
                >
                    <span ref={dataRef}></span>
                </CSVLink>
            </div>
        </div>
    );
};

export default HomePageExports;
